import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import RoadCarrierName from "../../components/roadCarrier/RoadCarrierDetail/RoadCarrierName.tsx";
import {useLocationFormState} from "../../components/roadCarrier/RoadCarrierForm/RoadCarrierUpdateForm";
import RoadCarrierUpdateFormProvider from "../../components/roadCarrier/RoadCarrierForm/RoadCarrierUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const RoadCarrierUpdateEditPage = () => {
    
    useTitle(t`Update Road Carrier`);

    const { roadCarrierId: id } = useParams();
    
    return (
        <Box data-testid="RoadCarrier-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="RoadCarrier-update-title"
                    >
                        <Trans>Edit Road Carrier</Trans>:  <RoadCarrierName id={id}/>
                    </Typography>
                    <RoadCarrierUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default RoadCarrierUpdateEditPage;
